import gql from 'graphql-tag';

export const fields = `
    tenantIds
    companyId
    company {
        id
        tenant {
            id
            name
            code
            isActive
        }
    }
    fleetId
    status
    engineModelId
    engineModel {
        id
        name
    }
    engineFlyingHours
    fleetAircraftId
    fleetAircraft {
        id
        tenantIds
        plate
        serialNumber
    }
    position
    serialNumber
    createdAt
    updatedAt
`;

export const fieldsWithFlyingHours = `
    ${fields}
    engineFlyingHours
`;

export const relationsFields = `
`;

// default methods
export const paginationQuery = gql`
    query DigitaiPaginateFleetAircraftEngines(
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        pagination: digitaiPaginateFleetAircraftEngines(
            query: $query
            constraint: $constraint
        ) {
            total
            rows
            count
        }
    }
`;

export const getQuery = gql`
    query DigitaiGetFleetAircraftEngines(
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        objects: digitaiGetFleetAircraftEngines(
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const findByIdQuery = gql`
    query DigitaiFindFleetAircraftEngineById(
        $id: ID
        $constraint: QueryStatement
    ) {
        object: digitaiFindFleetAircraftEngineById(
            id: $id
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const findQuery = gql`
    query DigitaiFindFleetAircraftEngine(
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        object: digitaiFindFleetAircraftEngine(
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const createMutation = gql`
    mutation DigitaiCreateFleetAircraftEngine (
        $payload: DigitaiCreateFleetAircraftEngineInput!
    ) {
        digitaiCreateFleetAircraftEngine (
            payload: $payload
        ) {
            ${fields}
        }
    }
`;

export const insertMutation = gql`
    mutation DigitaiCreateFleetAircraftEngines(
        $payload: [DigitaiCreateFleetAircraftEngineInput]!
    ) {
        digitaiCreateFleetAircraftEngines(payload: $payload)
    }
`;

export const updateByIdMutation = gql`
    mutation DigitaiUpdateFleetAircraftEngineById (
        $payload: DigitaiUpdateFleetAircraftEngineByIdInput!
        $constraint: QueryStatement
    ) {
        digitaiUpdateFleetAircraftEngineById (
            payload: $payload
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const updateMutation = gql`
    mutation DigitaiUpdateFleetAircraftEngines (
        $payload: DigitaiUpdateFleetAircraftEnginesInput!
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiUpdateFleetAircraftEngines (
            payload: $payload
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteByIdMutation = gql`
    mutation DigitaiDeleteFleetAircraftEngineById (
        $id: ID!
        $constraint: QueryStatement
    ) {
        digitaiDeleteFleetAircraftEngineById (
            id: $id
            constraint: $constraint
        ) {
            ${fieldsWithFlyingHours}
        }
    }
`;

export const deleteMutation = gql`
    mutation DigitaiDeleteFleetAircraftEngines (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiDeleteFleetAircraftEngines (
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;
